import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/common/ui/badge'
import { PartnerPlayerSummaryModel } from '@/modules/manage-player/type'
import { Link } from 'react-router-dom'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'

export const columns: ColumnDef<PartnerPlayerSummaryModel>[] = [
	{
		accessorKey: 'username',
		header: 'ชื่อผู้ใช้',
		cell: ({ row }) => (
			<UsernameCell
				username={
					(row.original as Record<string, unknown>).username as string | null
				}
			/>
		),
	},
	{
		accessorKey: 'phone',
		header: 'เบอร์โทรศัพท์',
		cell: ({ row }) => {
			const playerId = row.original.id
			const phone = row.getValue('phone') as string
			return (
				<Link
					to={`/operator/get-player-list/player-detail/${playerId}`}
					className="font-medium text-primary hover:underline"
				>
					<PhoneCell playerId={playerId} phone={phone} />
				</Link>
			)
		},
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สมัคร',
		cell: ({ row }) => {
			const createdAt = row.getValue('createdAt') as string
			return new Date(createdAt).toLocaleDateString('th-TH', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			})
		},
	},
	{
		accessorKey: 'isBanned',
		header: 'สถานะ',
		cell: ({ row }) => {
			const isBanned = row.getValue('isBanned') as boolean
			return isBanned ? (
				<Badge variant="destructive">ถูกแบน</Badge>
			) : (
				<Badge variant="default">ปกติ</Badge>
			)
		},
	},
	{
		accessorKey: 'depositWithBonus',
		header: 'ฝากมีโบนัส',
		cell: ({ row }) => {
			const value = row.getValue('depositWithBonus') as number
			return (
				<span className="font-medium text-green-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'depositWithoutBonus',
		header: 'ฝากไม่มีโบนัส',
		cell: ({ row }) => {
			const value = row.getValue('depositWithoutBonus') as number
			return (
				<span className="font-medium text-green-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'totalDeposit',
		header: 'ยอดฝากรวม',
		cell: ({ row }) => {
			const value = row.getValue('totalDeposit') as number
			return (
				<span className="font-bold text-green-700">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'totalWithdraw',
		header: 'ยอดถอนรวม',
		cell: ({ row }) => {
			const value = row.getValue('totalWithdraw') as number
			return (
				<span className="font-bold text-red-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'transferIn',
		header: 'แทงเสีย',
		cell: ({ row }) => {
			const value = row.getValue('transferIn') as number
			return (
				<span className="font-bold text-red-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'transferOut',
		header: 'แทงได้',
		cell: ({ row }) => {
			const value = row.getValue('transferOut') as number
			return (
				<span className="font-bold text-green-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'bonus',
		header: 'โบนัส',
		cell: ({ row }) => {
			const value = row.getValue('bonus') as number
			return (
				<span className="font-medium text-amber-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
	{
		accessorKey: 'profit',
		header: 'กำไร',
		cell: ({ row }) => {
			const value = row.getValue('profit') as number
			const isPositive = value >= 0
			return (
				<span
					className={`font-bold ${isPositive ? 'text-emerald-600' : 'text-red-600'}`}
				>
					{isPositive ? '' : '-'}
					{Math.abs(value).toLocaleString('th-TH', {
						minimumFractionDigits: 2,
					})}
				</span>
			)
		},
	},
	{
		accessorKey: 'partnerShare',
		header: 'ส่วนแบ่ง',
		cell: ({ row }) => {
			const value = row.getValue('partnerShare') as number
			return (
				<span className="font-bold text-purple-600">
					{value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}
				</span>
			)
		},
	},
]
